export const BASE_URL =
  import.meta.env.VITE_ENVIRONMENT === "development"
    ? import.meta.env.VITE_REACT_APP_BASE_URL
    : import.meta.env.VITE_PROD_BASE_URL

export const FACEBOOK_BASE_URL = import.meta.env.VITE_FACEBOOK_BASE_URL

const createURL = (path) => `${BASE_URL}/${path}`
const createFacebookURL = (path) => `${FACEBOOK_BASE_URL}/${path}/`

// ads
export const CREATIVES_URL = createURL("ads/creatives")
export const SEARCH_LANDING_PAGES = createURL("ads/landing-page/search")
export const LANDING_PAGES_URL = createURL("landing-pages")
export const UPDATE_ADS_URL = createURL("ads")

// ad copies
export const AD_COPIES_URL = createURL("ad-copies")
// users
export const USER_URL = createURL("users")

export const GET_FILES_AND_FOLDERS_URL = createURL("folder")

// default values
export const DEFAULT_VALUES_URL = createURL("default-values")

// Campaign URLs
export const FACEBOOK_CAMPAIGNS_URL = `campaigns`

// Ad Sets URLs
export const FACEBOOK_ADSETS_URL = `adsets`

// Thumbnail URLs
export const FACEBOOK_THUMBNAIL_URL = `thumbnails`

// Creative URLs
export const FACEBOOK_CREATIVES_URL = createURL(`creatives`)
export const FACEBOOK_AD_IMAGES_URL = createFacebookURL(`adimages`)

// Ad URLs
export const FACEBOOK_ADS_URL = `ads`

// Preview and Insights URLs
export const FACEBOOK_AD_PREVIEW_URL = createFacebookURL("previews")
export const FACEBOOK_AD_INSIGHTS_URL = createFacebookURL("insights")

// ad-post-attempts
export const AD_POST_ATTEMPTS_URL = createURL("ad-post-attempts")

// ad videos
export const FACEBOOK_ADVIDEOS_URL = "advideos"

export const FACEBOOK_AD_CREATIVE_URL = createFacebookURL("adcreatives")

// ml urls
export const UNGROUP_CREATIVES_URL = "ungroup_creatives"
export const GROUP_CREATIVES_FROM_FOLDER_URL = "group_creatives_from_folder"
export const GET_DUPLICATE_CREATIVE_URL = "duplicate_creative_cdn_url"
export const GET_SYNCED_FOLDER_IDS = "fetch_synced_folder_ids"
export const SYNC_AND_PROCESS_CREATIVE_FOLDER = "enqueue_sycn_folder"
export const GET_FOLDER_SYNC_AND_PROCESS_STATUS = "status"
export const GET_MULTIPLE_STATUS = "multi_status"
export const SAVE_FB_ADS_LAUNCH_URL = "save_fb_ads_launch"
export const LAUNCH_FB_ADS_BY_BATCH = "launch_fb_ads_by_batch"
export const FETCH_FB_AD_LAUNCH_LOGS = "fetch_fb_ad_launch_logs"
export const LAUNCH_SINGLE_FB_ADS_BY_LAUNCH_ID =
  "launch_single_fb_ad_by_launch_id"
export const GET_AD_ACCOUNTS_URL = "facebook_adaccounts"
export const GET_ALL_AD_ACCOUNTS_URL = "fetch_all_adaccounts"
export const ML_DEFAULT_VALUES_URL = "default_values"
export const ML_UPDATE_DEFAULT_VALUES_URL = "update_default_values"
export const ML_CREATE_DEFAULT_VALUES_URL = "create_default_values"
export const GET_FOLDERS_FROM_GOOGLE_DRIVE = "fetch_folders_from_google_drive"
export const QUICK_LAUNCH =
  "quick_launch"
